import BaseRepository from "./BaseRepository";
import BOMRematchAPICall from "../service/BOMRematchAPICall";

class BOMReMatchRepository extends BaseRepository {
    fetchStaticColumns = async () => {
        return await new BOMRematchAPICall().fetchStaticColumns();
    };
    fetchSavedColumnsDataByBomID = async (bomId) => {
        return await new BOMRematchAPICall().fetchSavedColumnsDataByBomID({bomId});
    };
    fetchSavedColumnsPreferenceByBomID = async (bomId) => {
        return await new BOMRematchAPICall().fetchSavedColumnsPreferenceByBomID({bomId});
    };
    saveColumnsPreferenceByBomID = async (bomId, sequenceNumber, columnMappingList) => {
        return await new BOMRematchAPICall().saveColumnsPreferenceByBomID({
            bomId,
            sequenceNumber,
            columnMappingList
        });
    };
}

export default BOMReMatchRepository;